<template >
    <el-dialog title="问题管理" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true" width="880px"
        @close="() => this.$emit('onCategoryManagementClosed')">
        <div class="filter-container flex">
            <el-button icon="el-icon-edit" type="primary" @click="createCategory">新建</el-button>

            <div>
                <el-select v-model="listQuery.state" placeholder="状态" clearable @change="onFilteState">
                    <el-option label="上架" :value="1" />
                    <el-option label="下架" :value="0" />
                </el-select>
            </div>
        </div>

        <el-table v-loading="tableLoading" :data="tableData" element-loading-text="Loading" border fit
            highlight-current-row>
            <el-table-column label="序号" type="index" width="82" align="center" />
            <el-table-column label="分类" prop="name" min-width="110" align="center"></el-table-column>
            <el-table-column label="权重" prop="sort" width="110" align="center"></el-table-column>
            <el-table-column label="状态" width="110" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.state === 1" type="success">上架</el-tag>
                    <el-tag v-if="!scope.row.state" type="danger">下架</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="148" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEditCategory(scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.state === 1" type="warning" size="mini"
                        @click="handleTakeDown(scope.row.id, '下架')">下架</el-button>
                    <el-button v-else-if="scope.row.state === 0" type="primary" size="mini"
                        @click="handleTakeDown(scope.row.id, '上架')">上架</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </div>

        <el-dialog :title="createModalTitle" :visible.sync="createModal" :close-on-click-modal="false"
            :destroy-on-close="true" append-to-body width="480px">
            <el-form :model="form" :rules="rules" ref="form" label-width="78px">
                <el-form-item label="分类名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="权重" prop="sort">
                    <el-input v-model.number="form.sort" placeholder="请输入权重"></el-input>
                </el-form-item>
                <div style="margin-left: 78px;">
                    <el-button @click="createModal = false">返回</el-button>
                    <el-button type="primary" @click="handleSubmit('form')">提交</el-button>
                </div>
            </el-form>
        </el-dialog>
    </el-dialog>
</template>

<script>
import request from "@/utils/request";

export default {
    data: () => ({
        tableLoading: false,
        tableData: [],
        listQuery: {
            page: 1,
            limit: 10,
            state: null
        },
        total: null,
        createModal: false,
        createModalTitle: '新建',
        rules: {
            name: [
                { required: true, message: '请输入分类名称', trigger: 'blur' }
            ],
            sort: [
                { type: 'number', required: true, message: '请输入权重', trigger: 'blur' }
            ]
        },
        form: {
            id: null,
            name: '',
            sort: ''
        }
    }),
    props: {
        show: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        async getList() {
            this.tableLoading = true
            try {
                const { data } = await request({
                    url: "/api/backend/basics/help/type/list",
                    method: "GET",
                    params: this.listQuery

                })
                let formatData = data.data.sort((v1, v2) => v2.sort - v1.sort)

                this.tableData = formatData
                this.total = data.total
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '请求失败!'
                });
            }
            this.tableLoading = false
        },
        onFilteState() {
            this.getList()
        },
        // 更改模式
        setActiveModalType(type) {
            this.activeModalType = type
        },
        createCategory() {
            this.form = {
                id: null,
                name: '',
                sort: ''
            }
            this.createModalTitle = "新建"
            this.createModal = true
        },
        handleEditCategory({ id, name, sort }) {
            this.form = { id, name, sort }
            this.createModalTitle = "编辑"
            this.createModal = true
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        async handleTakeDown(id, text) {
            this.$confirm("此操作将" + text + "该问题, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    request({
                        url: "/api/backend/basics/help/type/state",
                        method: "post",
                        data: { id: id }
                    }).then(() => {
                        this.getList();
                        this.$message({
                            type: "success",
                            message: "操作成功!"
                        });
                    });
                })
        },
        handleSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        await request({
                            url: "/api/backend/basics/help/type/add",
                            method: "POST",
                            data: this.form
                        })
                        this.$message({
                            message: `${this.createModalTitle}项目成功!`,
                            type: 'success'
                        });
                        this.createModal = false
                        this.getList()
                    } catch {
                        this.$message.error('出错了!');
                    }
                }
            });
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped></style>